// Function to clear all session storage
export const clearAllLocalStorage = async () => {
	try {
		sessionStorage.clear();
		window.location = "/signin";
	} catch (e) {
		throw e
	}
}